import { Component, Input, OnInit } from '@angular/core';
import { FormBuilder, Validators, FormGroup } from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { GlobalService } from 'app/global/global.service';
import { RejectDocumentService } from './reject-document.service';

@Component({
  selector: 'app-reject-document',
  templateUrl: './reject-document.component.html',
  styleUrl: './reject-document.component.scss'
})
export class RejectDocumentComponent implements OnInit {
  @Input() roleId: number;
  @Input() document_id: number;
  @Input() is_sender: number;
  public rejectDocument: FormGroup;
  constructor(
    private formBuilder: FormBuilder,
    private globalService: GlobalService,
    public activeModal: NgbActiveModal,
    private rejectDocumentService:RejectDocumentService
  ) { }
  public submitted:boolean = false;
  public rejectDocumentLoader:boolean = false;
  ngOnInit(): void {
    this.initForm();
  }

  initForm() {
    this.rejectDocument = this.formBuilder.group({
      reason: ['', Validators.required],
    })
  }

  onSubmit() {
    this.submitted = true;
    if (this.rejectDocument.invalid) {
      return;
    }
    this.submitted = false;
    this.rejectDocumentLoader = true;
    this.rejectDocumentService.rejectDocument(this.roleId, this.document_id, this.rejectDocument.value).subscribe({
      next: () => {
        window.location.reload();
      },
      error: (error) => {
        this.rejectDocumentLoader = false;
        this.globalService.toastrError(error);
      }
    })
  }

}